export { GTM } from "./GTM";